import { ProgramCategoryEnum } from '../../../../uc-api-sdk';

export const acceptedEnrollmentPrograms = [
  ProgramCategoryEnum.CCM,
  ProgramCategoryEnum.RPM,
  ProgramCategoryEnum.APCM,
  ProgramCategoryEnum.VALUE_BASED
];
